import { render, staticRenderFns } from "./vuetiform-checkboxes.vue?vue&type=template&id=f5c70b50&scoped=true&"
import script from "./vuetiform-checkboxes.vue?vue&type=script&lang=js&"
export * from "./vuetiform-checkboxes.vue?vue&type=script&lang=js&"
import style0 from "./vuetiform-checkboxes.vue?vue&type=style&index=0&id=f5c70b50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../@vue-modules/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c70b50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../@vue-modules/vuetify/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
